import { Component, OnInit } from '@angular/core';
import { HospitalService } from '../../_service/hospital.service';
import { DoctorService } from '../../_service/doctor.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LabService } from 'src/app/_service/lab.service';
declare var $: any;

@Component({
  selector: 'app-addedit-lab',
  templateUrl: './addedit-lab.component.html',
  styleUrls: ['./addedit-lab.component.css']
})
export class AddeditLabComponent implements OnInit {
  placements = ['left'];
  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  cancelText = 'No <i class="fas fa-times"></i>';
  confirmClicked = false;
  cancelClicked = false;fileDeleting:boolean = false;

  labForm: FormGroup; submitted = false; loading: boolean = false; cities = []; LabId: any = ''; uploading: boolean = false; myrole: string;
  s3url = ''; circles = []; lab_city: boolean = true; circles_copy = []; cities_copy = [];activeTab = '0';doc_type:string='';allUploads=[];
  constructor(private labapi: LabService, private hospitalapi: HospitalService, private router: Router, private sharedapi: SharedService, private formBuilder: FormBuilder, public leadapi: LeadsService, private activatedRoute: ActivatedRoute, private doctorapi: DoctorService) {
    this.sharedapi.getRole()
      .subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.getcircle();
    let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
    let vaildEmailAddress: any = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@" + "[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
    let passwordPattern = "^[a-zA-Z0-9]{8,}$";

    this.labForm = this.formBuilder.group({
      'mobile': [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
      'email': [null, Validators.compose([Validators.required, Validators.pattern(vaildEmailAddress)])],
      'name': [null, Validators.required],
      'status': [null, Validators.required],
      'circle_id': [null, Validators.required],
      'city_id': [null, Validators.required],
      'address': [null, Validators.required],
    });


    this.activatedRoute.params.subscribe(params => {
      if (params['lab_id']) {
        this.LabId = params['lab_id'];
        this.patchLabData();
      }

    });

  }

  get f() { return this.labForm.controls; }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'city') {
      $("#citySearch").val('');
      $("#citySearch").focus();
      this.cities = this.cities_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if (type == 'cities') {
      this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
    }
  }


  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  async getCircleCities(circle_id) {
    let qString = 'circle=' + circle_id;
    await this.doctorapi.getCircle_cities(qString).subscribe((data: any) => {
      if (data.status) {
        this.cities = data.data;
        this.cities_copy = this.cities;
        this.lab_city = false;
      } else {
        this.cities = [];
        this.lab_city = false;
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  ngOnInit(): void {
    this.s3url = localStorage.getItem('s3url');
  }



  async patchLabData() {

    await this.labapi.getLabData(this.LabId).subscribe((response: any) => {
      if (response.status) {
        this.getCircleCities(response.data.circle_id)
        this.allUploads = response.uploads;
        this.labForm.patchValue({
          'mobile': response.data.mobile,
          'email': response.data.email,
          'name': response.data.name,
          'status': response.data.status,
          'city_id': response.data.city_id,
          'circle_id': response.data.circle_id,
          'address': response.data.address,
        })
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async createLab() {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.labForm.invalid) {
      this.loading = false;
      return;
    }
    //For Update Lab...//
    if (this.LabId) {
      this.labForm.value.id = parseInt(this.LabId);
      this.labapi.updateLab(this.labForm.value)
        .subscribe((data: any) => {
          this.submitted = false;
          this.loading = false;
          if (data.status) {
            this.sharedapi.presentToast('Lab Update Successfully');
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
    } else {
      //For Add Lab//
      await this.labapi.addLab(this.labForm.value)
        .subscribe((data: any) => {
          this.submitted = false;
          this.loading = false;
          if (data.status) {
            this.sharedapi.presentToast('Lab Added Successfully');
            this.LabId = data.lastId;
            this.router.navigateByUrl('update-lab/'+this.LabId);
            this.patchLabData();
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
    }
  }

  async selectFile(event)
  {
      if(this.doc_type!=undefined)
      {
          this.uploading = true;
          let file = event.target.files.item(0);
          const formData = new FormData();
          formData.append('upload_type',this.doc_type)
          formData.append('file', file);
          await this.labapi.uploadLabDocs(this.LabId, formData)
          .subscribe((data:any) => {
              this.uploading = false;
              if(data.status)
              {
                  this.sharedapi.presentToast('File uploaded Successful');
                  window.location.reload();
                  this.patchLabData();
              }
              else
              {
                  this.sharedapi.presentToast(data.msg);
              }
            }, error =>
              {
                  this.uploading = false;
                  this.sharedapi.checkError(error);
              });
      }else{
          this.sharedapi.presentToast('Please select Document Type');
      }
  }

  removeFile(fileId)
    {
        this.fileDeleting = true;
        this.labapi.deleteLabFiles(fileId).subscribe((data:any) => {
            this.fileDeleting = false;
            if(data.status)
            {
              window.location.reload();
            }else{
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }


}
